import * as React from "react";
import styles from "../styles/pages/sale.module.scss";
import { withRouter } from "next/router";
import { ISale } from "../types/sale";
import LazyProductImage from "../components/lazy-product-image/lazy-product-image";
import { transformImage, formatNextHome, formatPublicHome } from "../utils";
import MetaHeader from "../components/meta-header/meta-header";
import FooterNewComponent from "../new-components/footer/Footer";
import nextI18NextConfig from "../next-i18next.config.js";
import { HeaderNewComponent } from "../new-components/header/Header";
import KeysNewComponent from "../new-components/home/Keys/Keys";
import AppNewComponent from "../new-components/sale/App/App";
import { trackPage } from "../api";
import { withTranslation } from "next-i18next";
import { canonical } from "../config";
import { getLang } from "../utils/lang";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Image from "next/image";
import { catalogApi } from "../api/catalog";
class SaleScreen extends React.Component<
  {
    router: any;
    t: any;
    sale?: ISale;
    i18n?: any;
    store: "fr" | "us";
  },
  {}
> {
  public getTrad = (str: string) => {
    return this.props.t(str);
  };

  get getTitle() {
    if (this.props.sale) {
      if (this.props.sale.sale_ended) {
        return `${this.props.sale.name} | ${this.getTrad("sale_ongoing")}`;
      }
      return `${this.props.sale.name} | ${this.getTrad("sale_ongoing")}`;
    }
    return "";
  }

  public componentDidMount() {
    trackPage("Vente");
    document.title = "Choose X " + this.props.sale?.name;
  }

  get getDescription() {
    let description = "";
    if (this.props.sale.sale_ended) {
      description = `${this.getTrad("sale_delivery")}`;
    } else if (this.props.sale.sale_started) {
      description = `${this.getTrad("basic")} ${formatPublicHome(
        this.props.sale.end_at,
        getLang(this.props.i18n),
        this.props.sale.store
      )}. ${this.getTrad("sale_delivery")}`;
    } else {
      description = `${this.getTrad("basic")} ${formatNextHome(
        this.props.sale.start_at,
        this.props.sale.end_at,
        getLang(this.props.i18n),
        this.props.sale.store
      )}. ${this.getTrad("sale_delivery")}`;
    }
    // Remove any <b> and </b> tags from the description
    return description.replace(/<b>/g, "").replace(/<\/b>/g, "");
  }

  get getMainImage() {
    if (this.props.sale && this.props.sale.image_header) {
      return transformImage(this.props.sale.image_header, "1200");
      // return `https://img.appchoose.io/unsafe/1200x630/filters:watermark(https://public.choose.app/website/new/images/logo-${
      //   this.props.sale.dark_color ? "white" : "black"
      // }.png,443,272,50)/prod/${
      //   this.props.sale.image_header.split("/prod/")[1]
      // }`;
    }
    return "";
  }

  get getAppleMeta() {
    let path = this.props.router.asPath
      .replace("/", "")
      .replace("sale/", "sales/")
      .replace("tester/", "sales/")
      .replace("upcoming/", "sales/");
    if (path.includes("?")) {
      path = path.split("?")[0];
    }
    let newLocation = `chooseapp://${encodeURI(path)}`;
    if (
      this.props.router.asPath.match(/(sales|sale)/) &&
      this.props.sale &&
      !this.props.sale.sale_started
    ) {
      newLocation = `chooseapp://${encodeURI(
        path.replace("sales", "preview")
      )}`;
    }
    return newLocation;
  }

  public getImage = ({ src, width }: any) => {
    return transformImage(src, width + "x");
  };

  get getText() {
    if (this.props.sale) {
      if (this.props.sale.sale_ended) {
        return this.getTrad("sale_ended");
      } else if (this.props.sale.sale_started) {
        return `${this.getTrad("sale_ongoing")} ${formatPublicHome(
          this.props.sale.end_at,
          getLang(this.props.i18n),
          this.props.sale.store
        )}`;
      }
      return `${this.getTrad("sale_next")} ${formatNextHome(
        this.props.sale.start_at,
        this.props.sale.end_at,
        getLang(this.props.i18n),
        this.props.sale.store
      )}`;
    }
    return "";
  }

  get setSchema() {
    return {
      __html: this.props.sale
        ? `{"@context": "http://schema.org",
                "@type": "SaleEvent",
                  "startDate": "${this.props.sale.start_at}",
                   "endDate": "${this.props.sale.end_at}",
                   "location":"appchoose.io",
                   "description": "${this.getDescription
                     .replace(/<b>/g, "")
                     .replace(/<\/b>/g, "")}",
                  "name": "${
                    this.props.sale.name
                      ? this.props.sale.name
                          .replace(/"/g, "")
                          .replace(/(\r\n|\n|\r)/gm, " ")
                      : null
                  }",
                  "image":"${this.getMainImage}",
                  "url": "${canonical}sales/${this.props.sale.url}"
            }`.replace(/\n/g, "")
        : "",
    };
  }

  public render() {
    return (
      <div className={styles.sale}>
        {this.props.sale ? (
          <MetaHeader
            pageTitle={this.getTitle}
            canonical={canonical + "sales/" + this.props.sale.url}
            appleArguments={this.getAppleMeta}
            keywords={this.props.sale.name}
            description={this.getDescription
              .replace(/<b>/g, "")
              .replace(/<\/b>/g, "")}
            title={this.getTitle}
            image={this.getMainImage}
            noIndex={true}
          />
        ) : null}

        <HeaderNewComponent
          showSlogan={true}
          disableScroll={true}
          hideBtns={true}
          store={this.props.store}
          language={this.props.i18n.language}
        />
        <div className="container align-items-center">
          <div className={`row ${styles.sale_data}`}>
            <Image
              className={`col-7 col-sm-12 col-md-12 ${styles.image}`}
              loader={this.getImage}
              layout="fixed"
              src={
                this.props.sale && this.props.sale.image_header
                  ? this.props.sale.image_header
                  : ""
              }
              alt={`image ${this.props.sale?.name}`}
              width={708}
              height={386}
            />
            <div className="col-sm-0 col-1 col-md-0" />
            <div className={`col-4 col-sm-12 col-md-10 ${styles.sale_info}`}>
              <h1>{this.props.sale?.name}</h1>
              <p className={styles.category}>{this.props.sale?.category}</p>
              {this.props.sale?.badges && this.props.sale?.sale_started ? (
                <div className={styles.badges}>
                  {this.props.sale?.badges.map((badge) => {
                    return (
                      <div className={styles.badge} key={badge.text}>
                        <LazyProductImage
                          height="16"
                          width="16"
                          disableWebp={true}
                          src={badge.image}
                          alt={badge.text}
                        />
                        <p>{this.props.t(badge.code)}</p>
                      </div>
                    );
                  })}
                </div>
              ) : null}
              <p
                className={styles.date}
                dangerouslySetInnerHTML={{ __html: this.getText }}
              />
              <AppNewComponent className={styles.app} />
            </div>
          </div>
          <hr className={styles.sale_hr} />
        </div>
        <KeysNewComponent />
        <FooterNewComponent store={this.props.store} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={this.setSchema}
        />
      </div>
    );
  }
}

export const getServerSideProps = async (props) => {
  const tmp = {
    props: {
      ...(await serverSideTranslations(
        props.query.language ||
          props.query.lang ||
          props.locale ||
          props.defaultLocale ||
          "fr",
        ["common", "keys", "sale"],
        nextI18NextConfig as any
      )),
      ...props.query,
      store: props.query.store || "fr",
    },
  } as any;
  try {
    const id = props.query.id ? props.query.id.split("@v=")[0] : undefined;

    if (props.query.id) {
      const sale = await catalogApi.getSale(id, props.query.store);

      if (sale) {
        tmp.props.sale = sale;
      } else {
        return {
          redirect: {
            destination: "/error?code=not_found&from=sale&id=" + id,
            permanent: false,
          },
        };
      }
    } else {
      return {
        redirect: {
          destination: "/error?code=no_id&from=sale",
          permanent: false,
        },
      };
    }
  } catch (error) {
    tmp.props.error = error;
    tmp.props.sale = {};
    tmp.props.isServerRendered = !!props.req;
    tmp.props.store = props.query.store || "fr";
  }
  return tmp;
};

export default withTranslation("sale")(withRouter(SaleScreen));
